/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M6.6667 5.6667c-.5523 0-1 .4477-1 1s.4477 1 1 1h10.6666c.5523 0 1-.4477 1-1s-.4477-1-1-1H6.6667ZM5.6667 12c0-.5523.4477-1 1-1h10.6666c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.6667c-.5523 0-1-.4477-1-1ZM6.6667 16.3333c-.5523 0-1 .4477-1 1s.4477 1 1 1h10.6666c.5523 0 1-.4477 1-1s-.4477-1-1-1H6.6667Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.3333 4c0-2.2091 1.7909-4 4-4h13.3334c2.2091 0 4 1.7909 4 4v16c0 2.2091-1.7909 4-4 4H5.3333c-2.2091 0-4-1.7909-4-4V4Zm4-2h13.3334c1.1045 0 2 .8954 2 2v16c0 1.1046-.8955 2-2 2H5.3333c-1.1045 0-2-.8954-2-2V4c0-1.1046.8955-2 2-2Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuListing'
);
